
const products_on_page = document.getElementById('blog-articles');
const nextUrl = document.getElementById('paginateNext');
let next_url = nextUrl ? nextUrl.dataset.nextUrl : null;

const load_more_btn = document.querySelector('.load-more .load-more_btn');
const load_more_spinner = document.querySelector('.load-more .loading__spinner');

async function getNextPage() {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
    return null; 
  }
}

async function loadMoreProducts() {
  if (!next_url) {
    load_more_btn.style.display = 'none';
    return;
  }

  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'inline-block';

  let nextPage = await getNextPage();
  if (!nextPage) {
    load_more_spinner.style.display = 'none';
    return;
  }

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.getElementById('blog-articles');
  const new_products = productgrid.getElementsByClassName('blog-articles__article');
  const newUrl = nextPageDoc.getElementById('paginateNext');
  const new_url = newUrl ? newUrl.dataset.nextUrl : null;

  if (new_url) {
    next_url = new_url;
    load_more_btn.style.display = 'inline-flex';
  } else {
    load_more_btn.style.display = 'none';
  }

  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }
}


if (next_url) {
  load_more_btn.onclick = function() { loadMoreProducts(); };
}
